import { mapGetters, mapMutations } from 'vuex';
import { formatBytes } from 'ca-js-helper';

const maxFilesize = ca.config('media.download.multiple.max_size');

const download = {
    computed: {
        ...mapGetters([
            'getGalleryMediaItemSelectedIds',
            'getDownloadManyUrl',
            'getGalleryItem',
            'getGalleryMediaSetItem',
            'getMediaSetSelectedCount',
            'getMediaSetSelectedIds',
            'getMediaSetMediaById',
            'getMediaSetSelectedFilesize',
            'getGalleryMediaItemSelectedFilesize',
        ]),
    },
    methods: {
        ...mapMutations(['setGalleryMediaSelectedItems']),
        async doDownload(e, item) {
            const link = document.createElement('a');

            if (item.isImage) {
                link.href = `${item.url}?p=download-original`;
            } else if (item.isMediaSet) {
                const base64Items = btoa(JSON.stringify({ media: [item.id] }));
                link.href = this.getDownloadManyUrl(base64Items);
                const filesize = item.mediaTotalFilesize;
                if (filesize >= maxFilesize) {
                    this.showMaxFilesizeError();
                    return;
                }
            } else {
                link.href = `${item.url}?p=download`;
            }

            link.click();

            const activity = apiClient.create('Activity', {
                description: 'downloaded',
                subject_type: item.isMediaSet ? 'set' : 'media',
                subject_id: item.id,
                properties: {
                    route: link.href,
                },
            });

            await activity.save();
        },
        doDownloadSelected(e, isMediaSet = false) {
            let selectedCount = 0;
            let selectedIds = [];
            let filesize = 0;

            if (isMediaSet) {
                selectedCount = this.getMediaSetSelectedCount;
                selectedIds = this.getMediaSetSelectedIds;
                filesize = this.getMediaSetSelectedFilesize;
            } else {
                selectedCount = this.getGalleryMediaItemSelectedCount;
                selectedIds = this.getGalleryMediaItemSelectedIds;
                filesize = this.getGalleryMediaItemSelectedFilesize;
            }

            const isMaxFilesize = filesize >= maxFilesize;

            if (selectedCount > 0 && !isMaxFilesize) {
                if (selectedCount === 1) {
                    let item = false; // single selected item download
                    const itemId = selectedIds.pop();
                    if ((item = this.getGalleryItem(itemId)) || (item = this.getGalleryMediaSetItem(itemId))) {
                        return this.doDownload(null, item);
                    }
                }

                const mediaIds = { media: selectedIds };
                const base64Items = btoa(JSON.stringify(mediaIds));
                const downloadText = `Begin download <small>(${formatBytes(filesize)})</small>`;
                ca.confirm({
                    type: 'download',
                    html: `<p>Click the button below to begin your download.<p><a class="btn btn-primary btn-lg center-block" onclick="Swal.closeModal();" href="${this.getDownloadManyUrl(
                        base64Items
                    )}">${downloadText}</a>`,
                });

                // Activity log each item.
                selectedIds.forEach(async (id) => {
                    const isMediaSet = !this.getGalleryItem(id); // fails to find if set
                    const activity = apiClient.create('Activity', {
                        description: 'downloaded',
                        subject_type: isMediaSet ? 'set' : 'media',
                        subject_id: id,
                        properties: {
                            route: this.getDownloadManyUrl(base64Items),
                        },
                    });

                    await activity.save();
                });
            } else if (isMaxFilesize) {
                this.showMaxFilesizeError();
            }
        },
        doDownloadCameraFile(e, item) {
            const link = document.createElement('a');
            link.href = `${item.url}?p=download-meta`;
            link.click();
        },
        doDownloadOriginal(e, item) {
            const link = document.createElement('a');
            link.href = `${item.url}?p=download-original`;
            link.click();
        },
        showMaxFilesizeError() {
            ca.notify({
                type: 'error',
                icon: 'bomb',
                message: `The selected items exceed the maximum allowed filesize of: ${formatBytes(maxFilesize)}`,
                timeout: ca.config('toast.timeout'),
            });
        },
    },
};

export default download;
